import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { UppImageComponent } from '@unpispas/upp-wdgt';

@Component({
    selector: 'demo-upp-image',
    templateUrl: './demo-upp-image.html',
    styleUrls: ['../demo-common.scss', './demo-upp-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppImageComponent {
    isReadonly = true;
    selectedMode: 'upload' | 'config' = 'config';
    searchText = 'pizza margarita';
    crwidth = '200';
    crheight = '200';
    imageUpdated = false;

    /** Synced with upp-image value so delete clears the displayed image and Change stays visible. */
    imageSrc: string | null = 'https://picsum.photos/seed/product/300/300';

    constructor(private change: ChangeDetectorRef) {
    }

    toggleReadonly() {
        this.isReadonly = !this.isReadonly;
        this.change.markForCheck();
    }

    setMode(mode: 'upload' | 'config') {
        this.selectedMode = mode;
        this.change.markForCheck();
    }

    onImageChanged(imageRef: UppImageComponent) {
        this.imageSrc = imageRef.value;
        this.imageUpdated = true;
        this.change.markForCheck();
        setTimeout(() => {
            this.imageUpdated = false;
            this.change.markForCheck();
        }, 2000);
    }
}
